import BaseAssetPickerView from 'backbone/platform/views/assets/base_asset_picker_view.js'
import MediaLibraryAssetsLayoutView from 'backbone/platform/views/assets/media_library_assets_layout_view.js'

export default class MultiAssetPickerView extends BaseAssetPickerView
  rerenderActions: =>
    @actionsView.render(formValid: @_formValid())

  pickAssets: =>
    if @_formValid()
      assetCount = @assetsCollectionView.pickedAssets().length
      @_logMixpanelEvent("ml-assets-picked", { asset_count: assetCount})
      @assetsPickedCallback(@assetsCollectionView.pickedAssets())
      @assetsCollectionView.deselectAll()
      contently.ui.closeModal()

  _renderActions: ->
    super
    @actionsView.render(formValid: @_formValid())

  _attachTemplate: ->
    @$el.html @template
      activeTab: "upload"
      showChooseTab: @options.mediaLibraryAccess
      modalHeaderTitle: @options.modalHeaderTitle
      modalAttachText: @options.modalAttachText
      formValid: @_formValid()
      brandProfileId: @options.brandProfileId
      inputId: @options.inputId || "asset_uploader_input" # direct or multipart upload

  _renderCollection: ->
    @assetsCollectionView = new MediaLibraryAssetsLayoutView
      el: @$(".modal-assets-manager")
      brandProfileId: @options.brandProfileId
      collection: @options.mediaLibraryAssets
      mediaLibraryAccess: @options.mediaLibraryAccess
      page: @options.page
    @subviews.push(@assetsCollectionView)
    @$("#modal-tab1").append(@assetsCollectionView.render().$el)

  _setupDispatcher: ->
    super
    @dispatcher.bind("assetChanged", @rerenderActions)
    @dispatcher.bind("assetsPicked", @pickAssets)

  _teardownDispatcher: ->
    super
    @dispatcher.unbind("assetChanged")
    @dispatcher.unbind("assetsPicked")

  _formValid: ->
    return true unless @options.mediaLibraryAccess
    @assetsCollectionView?.pickedAssets().length > 0



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/multi_asset_picker_view.js.coffee